<template>
  <div v-if="visible" @click.stop="() => {}">
    <!-- 遮罩层 -->
    <div class="guide-mask" :style="maskStyle"></div>

    <!-- 指引组件 -->
    <div
      class="guide-step"
      :style="{
        left: `${left}px`,
        top: `${top}px`,
        width: `${width}px`,
      }"
    >
      <!-- 箭头指示器 -->
      <div
        class="guide-arrow"
        :class="arrowPosition"
        :style="arrowLeft ? { left: `${arrowLeft}px` } : {}"
      ></div>

      <!-- 指引内容卡片 -->
      <div class="guide-card">
        <!-- 标题 -->
        <div class="guide-title" v-if="title">
          {{ title }}{{ lastIndex === 1 ? "" : `(${guideIndex}/${lastIndex})` }}
        </div>

        <!-- 内容 -->
        <div class="guide-content">
          <slot>{{ content }}</slot>
        </div>

        <!-- 操作按钮 -->
        <div class="guide-actions">
          <el-button size="mini" @click="onPrev" v-if="guideIndex !== 1">
            上一步
          </el-button>
          <el-button size="mini" type="primary" @click="onNext">
            {{ guideIndex === lastIndex ? "完成" : "下一步" }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GuideStep",
  props: {
    left: {
      type: Number,
      default: 0,
    },
    arrowLeft: {
      type: Number,
      default: 0,
    },
    top: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: "新手指引",
    },
    content: {
      type: String,
      default: "",
    },
    guideIndex: {
      type: Number,
      default: 1,
    },

    lastIndex: {
      type: Number,
      default: 1,
    },
    width: {
      type: Number,
      default: 300,
      description: "指引卡片宽度",
    },

    // 目标元素信息（用于高亮显示）
    targetRect: {
      type: Object,
      default: () => ({}),
      description: "目标元素的位置信息，格式: {top, left, width, height}",
    },
    visible: {
      type: Boolean,
      default: false,
      description: "是否显示当前指引",
    },

    // 导航相关
    isLastStep: {
      type: Boolean,
      default: false,
      description: "是否为最后一步",
    },
    showSkip: {
      type: Boolean,
      default: true,
      description: "是否显示跳过按钮",
    },
    closeOnMaskClick: {
      type: Boolean,
      default: false,
      description: "点击遮罩层是否关闭指引",
    },

    // 箭头位置，相对于参考元素
    arrowPosition: {
      type: String,
      default: "bottom",
      validator: (val) => ["top", "bottom", "left", "right"].includes(val),
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    // 计算遮罩层样式，包括高亮区域
    maskStyle() {
      if (
        !this.targetRect ||
        !this.targetRect.width ||
        !this.targetRect.height
      ) {
        return {};
      }

      // 计算高亮区域的位置和大小
      const { top, left, width, height } = this.targetRect;

      // 创建遮罩层的剪切路径，只显示目标元素区域
      return {
        clipPath: `polygon(
            0 0, 100% 0, 100% 100%, 0 100%,
            0 ${top}px, ${left}px ${top}px,
            ${left}px ${top + height}px, ${left + width}px ${top + height}px,
            ${left + width}px ${top}px, 100% ${top}px,
            100% ${top + height}px, ${left + width}px ${top + height}px,
            ${left + width}px ${top}px, ${left}px ${top}px,
            ${left}px ${top + height}px, 0 ${top + height}px
          )`,
      };
    },
  },
  methods: {
    // 下一步或完成
    onNext() {
      // if (this.guideIndex === 4) {
      //   this.$store.commit("SET_GUIDE_INDEX", 1);
      //   this.$store.commit("SET_GUIDE_SHOW", false);
      // } else {
      //   this.$store.commit("SET_GUIDE_INDEX", this.guideIndex + 1);
      // }
      this.$emit("onNext");
    },
    // 上一步
    onPrev() {
      // this.$store.commit("SET_GUIDE_INDEX", this.guideIndex - 1);
      this.$emit("onPrev");
    },
  },
};
</script>

<style scoped>
.guide-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  pointer-events: auto;
}

.guide-step {
  position: absolute;
  z-index: 9999;
  pointer-events: auto;
}

.guide-card {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 16px;
  box-sizing: border-box;
}

.guide-title {
  font-size: 16px;
  font-weight: bold;
  color: #1f2329;
  margin-bottom: 8px;
}

.guide-content {
  font-size: 14px;
  color: #4e5969;
  margin-bottom: 16px;
  line-height: 1.5;
}

.guide-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.guide-arrow {
  position: absolute;
  width: 12px;
  height: 12px;
  background: #fff;
  transform: rotate(45deg);
}

/* 箭头位置样式 */
.guide-arrow.top {
  top: -6px;
  right: 20px;
  box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.05);
}

.guide-arrow.bottom {
  bottom: -6px;
  right: 20px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.05);
}

.guide-arrow.left {
  left: -6px;
  top: 20px;
  box-shadow: -2px 2px 4px rgba(0, 0, 0, 0.05);
}

.guide-arrow.right {
  right: -6px;
  top: 20px;
  box-shadow: 2px -2px 4px rgba(0, 0, 0, 0.05);
}
</style>
